import objectFitImages from 'object-fit-images'
import initHeader from './layout/header'
import initCards from './elements/cards'
import initReveal from './elements/reveal'

import initSplashBlocks from './blocks/splash'
import initMediaGalleryBlocks from './blocks/media-gallery'
import initContentBlocks from './blocks/content'
import initMapLegendBlocks from './blocks/map-legend'
import initMediaBlocks from './blocks/media'
import {addDebugOverlayEntry} from './define/shared'
import initFormBlocks from "./blocks/form"
import initMapSVGBlocks from "./blocks/map-svg"

initHeader()
initCards()
initReveal()

initSplashBlocks()
initMediaGalleryBlocks()
initContentBlocks()
initMapLegendBlocks()
initMediaBlocks()
initFormBlocks()
initMapSVGBlocks()

objectFitImages()


addDebugOverlayEntry('res', () => {
    return `${window.innerWidth}x${window.innerHeight}`
}, update => {
    window.addEventListener('load', update)
    window.addEventListener('resize', update)
    window.addEventListener('orientationchange', update)
})
